import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';

export default function useTranslationsOnImage({ imgRef }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      imgWidth: 0,
      imgHeight: 0,
    },
  });

  useEffect(() => {
    if (!imgRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      if (imgRef.current) {
        actions.setState({
          imgWidth: imgRef.current.offsetWidth,
          imgHeight: imgRef.current.offsetHeight,
        });
      }
    });

    resizeObserver.observe(imgRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [imgRef]);

  return {
    state,
  };
}
